import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { SEO_PAGES } from "@/lib/seoPages";

const SEO_LOCATION_LINKS = SEO_PAGES.filter((p) => p.kind === "location");
const SEO_EVENT_LINKS = SEO_PAGES.filter((p) => p.kind === "event");

const INSTAGRAM_URL = "https://www.instagram.com/luxuryportablerestroom";
const FACEBOOK_URL = "https://www.facebook.com/share/1B5bf6BXyk/";

export default function Footer() {
  return (
    <footer className="bg-charcoal text-ivory">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="h-display text-3xl md:text-4xl leading-tight">Luxury made simple.<br/>Luxury made for you.</div>
            <p className="mt-6 text-ivory/70 max-w-md">
              Elegant restroom trailers for weddings, festivals, corporate gatherings, and private events across Southern Utah.
            </p>
            <Link to="/booking" data-testid="footer-book-btn" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-champagne text-charcoal px-6 py-3 text-sm font-medium hover:bg-pebble transition-colors">
              Request a Booking
            </Link>
          </div>

          <div>
            <div className="overline text-ivory/60">Explore</div>
            <ul className="mt-4 space-y-2 text-ivory/80 text-sm">
              <li><Link to="/trailers" className="hover:text-champagne transition-colors">Our Trailers</Link></li>
              <li><Link to="/events" className="hover:text-champagne transition-colors">Events</Link></li>
              <li><Link to="/how-it-works" className="hover:text-champagne transition-colors">How It Works</Link></li>
              <li><Link to="/gallery" className="hover:text-champagne transition-colors">Gallery</Link></li>
              <li><Link to="/service-area" className="hover:text-champagne transition-colors">Service Area</Link></li>
              <li><Link to="/faqs" className="hover:text-champagne transition-colors">FAQs</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-ivory/60">Contact</div>
            <ul className="mt-4 space-y-3 text-ivory/80 text-sm">
              <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 shrink-0" /><a href="mailto:info@southernutaheventrentals.com" className="hover:text-champagne break-all">info@southernutaheventrentals.com</a></li>
              <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 shrink-0" /><a href="tel:+14352889909" className="hover:text-champagne">(435) 288-9909</a></li>
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /><span>St. George, Utah</span></li>
            </ul>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                data-testid="social-instagram"
                className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-white/20 text-ivory/80 hover:text-charcoal hover:bg-champagne hover:border-champagne transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Facebook"
                data-testid="social-facebook"
                className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-white/20 text-ivory/80 hover:text-charcoal hover:bg-champagne hover:border-champagne transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <span className="text-xs text-ivory/50 ml-2">@luxuryportablerestroom</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-white/10 grid md:grid-cols-2 gap-10">
          <div>
            <div className="overline text-ivory/60">Serving Southern Utah</div>
            <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-ivory/70 text-sm">
              {SEO_LOCATION_LINKS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/${p.slug}`} className="hover:text-champagne transition-colors">{p.h1}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="overline text-ivory/60">Trailer rentals by event</div>
            <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-ivory/70 text-sm">
              {SEO_EVENT_LINKS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/${p.slug}`} className="hover:text-champagne transition-colors">{p.h1}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-ivory/50">
          <span>© {new Date().getFullYear()} Southern Utah Event Rentals. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-champagne">Admin</Link>
            <span>Serving all of Southern Utah</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
